<template>
  <div>
    <v-list-item v-if="listItem" @click="downloadFile({ url: downloadUrl, docTitle: fileName })">
      <v-list-item-icon>
        <v-icon>mdi-download</v-icon>
      </v-list-item-icon>
      <v-list-item-subtitle class="wrap-normal">{{ $t('label.download') }}</v-list-item-subtitle>
    </v-list-item>

    <v-tooltip v-else class="d-none d-md-flex" style="z-index: 10000">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mx-0" small :color="color" @click.stop icon v-bind="attrs" v-on="on" :href="downloadUrl">
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('download') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import common from '@/mixins/common';
import { downloadFile } from '@/common/networkUtils';

export default {
  name: 'Download',
  mixins: [common],
  props: {
    fileName: {
      type: String,
      default: 'Filename',
    },
    listItem: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
    downloadUrl: {
      type: String,
    },
  },
  methods: {
    downloadFile,
  },
};
</script>
